import { PlainDate } from "@/temporal"
import { objectSchema, type KeysMatching } from "vue-utils"
import { DocumentUpload } from "./DocumentUpload"
import { extend, GenericEntity, Nullable } from "./GenericEntity"
import { UserTimeStamp } from "./UserTimeStamp"

export type ShipmentLogDocumentKey = KeysMatching<ShipmentLog, Nullable<DocumentUpload[]>>

export interface ShipmentLog extends GenericEntity {
	/** nth shipment for the associated TFS. Starts at 1 */
	shipmentNumber: number

	notificationOfShipments: Nullable<DocumentUpload[]>
	recoveryAtFacility: Nullable<DocumentUpload[]>
	additionalDocuments: Nullable<DocumentUpload[]>

	createdBy: UserTimeStamp
	shipmentDate: Nullable<PlainDate>

	cancelled: Nullable<UserTimeStamp>
	completed: Nullable<UserTimeStamp>
}

export const ShipmentLog = objectSchema<ShipmentLog>({
	...extend(GenericEntity),
	shipmentNumber: Number,

	notificationOfShipments: Nullable(DocumentUpload.array()),
	recoveryAtFacility: Nullable(DocumentUpload.array()),
	additionalDocuments: Nullable(DocumentUpload.array()),

	createdBy: UserTimeStamp,
	shipmentDate: Nullable(PlainDate.Schema),

	cancelled: Nullable(UserTimeStamp),
	completed: Nullable(UserTimeStamp),
})
